import { ICommandBase } from '@/commands/interface/iCommandBase';

// 複数コマンド
export class MultiCommand implements ICommandBase
{
    private commandList : Array<ICommandBase> = [];

    public get commandCount() { return this.commandList.length; }

    constructor()
    {
        this.commandList = [];
    }

    public addCommand(command : ICommandBase)
    {
        this.commandList.push(command);
    }

    public do() : void
    {
        for(var i = 0; i < this.commandList.length; ++i)
        {
            this.commandList[i].do();
        }
    }

    public undo() : void
    {
        // 取り消しは逆順に行う
        for(var i = this.commandList.length - 1; i >= 0; --i)
        {
            this.commandList[i].undo();
        }
    }

    public redo() : void
    {
        for(var i = 0; i < this.commandList.length; ++i)
        {
            this.commandList[i].redo();
        }
    }
}